import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';
import {
    Grid,
    Card,
    CardContent,
    makeStyles,
    Avatar,
    Checkbox,
    FormControlLabel,
    CardHeader,
    AppBar,
    Tabs,
    Tab,
    FormControl,
    Radio,
    RadioGroup,
    Switch,
    Popover,
    Typography,
    Chip,
    Box,
    Tooltip,
    LinearProgress,
    CircularProgress,
} from '@material-ui/core';
import { Block, Check, InfoOutlined, EmojiEvents, EventBusy } from '@material-ui/icons';
import {
    getGrupos,
    getPalavraFest,
    getPalavraFestCriancas,
    salvarParticipacaoMembro,
    salvarItem,
    salvarItemCrianca,
    getDesafioMeditacao,
    getMemorizacaoCompleta,
    getPalavraFestStatus,
} from '../../services/GruposApi';
import { getIdMembro } from '../../services/api';
import InformationDialog from '../../components/InformationDialog';

const useStyles = makeStyles(theme => ({
    avatar: {},
    radiogroup: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(1),
        userSelect: 'none',
    },
    grid: {
        marginTop: theme.spacing(1),
    },
    cardHeader: {},
    cardContent: {
        paddingTop: 0,
    },
    switchItem: {
        display: 'flex',
        alignItems: 'flex-start',
        userSelect: 'none',
        marginLeft: 0,
        marginBottom: 0,
        '& .MuiSwitch-root': {
            marginTop: -8,
        },
    },
    switchWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    infoIcon: {
        fontSize: 18,
        color: theme.palette.text.secondary,
        cursor: 'pointer',
        marginLeft: 4,
        marginTop: -8,
    },
    item: {
        display: 'flex',
        alignItems: 'flex-start',
        userSelect: 'none',
        marginLeft: 0,
        '& .MuiCheckbox-root': {
            paddingTop: 0,
            marginTop: -2,
        },
    },
    progressRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 4,
    },
    progressLabel: {
        minWidth: 110,
    },
    progressBar: {
        flex: 1,
        height: 8,
        borderRadius: 4,
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#fff',
        },
    },
    progressBarGreen: {
        flex: 1,
        height: 8,
        borderRadius: 4,
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#2E7D32',
        },
    },
    progressBarRed: {
        flex: 1,
        height: 8,
        borderRadius: 4,
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#F44336',
        },
    },
    progressValue: {
        minWidth: 40,
        textAlign: 'right',
    },
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const ControlePalavraFest = () => {
    const [dentroDoPeriodo, setDentroDoPeriodo] = useState(false);
    const [mostrarFestaVitoria, setMostrarFestaVitoria] = useState(false);

    const [grupos, setGrupos] = useState([]);
    const { indexGrupo } = useParams();
    const [palavraFest, setPalavraFest] = useState([]);
    const [isCarregandoGrupo, setCarregandoGrupo] = useState(true);
    const [error, setError] = useState('');
    const classes = useStyles();
    const [grupoSelecionado, setGrupoSelecionado] = useState(false);
    const history = useHistory();
    const [itens, setItens] = useState(Array(100000).fill(false));
    const MAX_ELEMENTS = 10;
    const [isCarregandoSemana, setCarregandoSemana] = useState(false);
    const [semana, setSemana] = useState('1');
    const [mostrarModalGrupo, setMostrarModalGrupo] = useState(false);
    const [palavraFestInativo, setPalavraFestInativo] = useState(false);
    const [mensagemInativo, setMensagemInativo] = useState('');
    const [desafioMeditacao, setDesafioMeditacao] = useState({
        conseguiu: false,
    });
    const [membrosMemorizacao, setMembrosMemorizacao] = useState([]);
    const [switchLiderEl, setSwitchLiderEl] = useState(null);
    const showPopoverSwitchLider = Boolean(switchLiderEl);
    const location = useLocation();
    const queryParams = queryString.parse(location.search);
    const admin = 'admin' in queryParams;

    async function fetchPalavraFest(idGrupoPequeno) {
        try {
            const response = await (
                await getPalavraFest(idGrupoPequeno, semana)
            ).data;
            const conseguiu = await (await getDesafioMeditacao(idGrupoPequeno))
                .data.conseguiu;
            const memorizacao = await (await getMemorizacaoCompleta(idGrupoPequeno))
                .data;
            setMembrosMemorizacao(memorizacao || []);
            setDesafioMeditacao({ conseguiu });
            return response;
        } catch (err) {
            return [];
        }
    }

    async function fetchPalavraFestCriancas(idMembro) {
        try {
            const response = await (
                await getPalavraFestCriancas(idMembro, semana)
            ).data;
            return response;
        } catch (err) {
            return [];
        }
    }

    async function verificarProfessorSemGrupo(grps) {
        let idMembroLider;

        if (grps.length > 0) {
            idMembroLider = grps[0].idMembroLider1;
        } else {
            idMembroLider = getIdMembro();
        }

        const verificandoGrupoCriancas = await fetchPalavraFestCriancas(
            idMembroLider
        );

        if (verificandoGrupoCriancas.length > 0) {
            grps.push({
                idGrupoPequeno: idMembroLider,
                isCriancaPalavraFest: true,
            });
        } else if (grps.length === 0) {
            setMostrarModalGrupo(true);
        }
    }

    async function fetchGrupos() {
        try {
            const statusResponse = await (await getPalavraFestStatus()).data;
            if (!statusResponse.ativo) {
                setPalavraFestInativo(true);
                setMensagemInativo(statusResponse.mensagem);
                setCarregandoGrupo(false);
                return;
            }

            setDentroDoPeriodo(statusResponse.dentro_do_periodo);
            setMostrarFestaVitoria(statusResponse.mostrar_festa_vitoria);

            const grps = await (await getGrupos()).data;
            //await verificarProfessorSemGrupo(grps);
            setGrupos(grps);
            setCarregandoGrupo(false);
        } catch (err) {
            setError(err);
        }
    }

    async function carregarTab(grpSelecionado) {
        setCarregandoSemana(true);
        setDesafioMeditacao({ conseguiu: false });
        setGrupoSelecionado(grpSelecionado);
        if (grpSelecionado) {
            let palavraFestRemoto = [];
            if (grpSelecionado && !grpSelecionado.isCriancaPalavraFest) {
                palavraFestRemoto = await fetchPalavraFest(
                    grpSelecionado.idGrupoPequeno
                );
            } else {
                palavraFestRemoto = await fetchPalavraFestCriancas(
                    grpSelecionado.idGrupoPequeno
                );
            }

            const its = {};
            (palavraFestRemoto || []).forEach((membro, idxMembro) => {
                membro.itens.forEach((item, idxItem) => {
                    its[MAX_ELEMENTS * idxMembro + idxItem] = !!item.situacao;
                });
            });

            setItens(Array(100000).fill(false));
            setPalavraFest(palavraFestRemoto || []);
            setItens(its);
        }
        setCarregandoSemana(false);
    }

    useEffect(() => {
        if (isCarregandoGrupo && !error) {
            fetchGrupos();
        } else if (indexGrupo) {
            carregarTab(grupos[indexGrupo]);
        } else {
            carregarTab(grupos[0]);
        }
    }, [isCarregandoGrupo, error, semana]);

    const selecionarGrupo = (event, grpSelecionado) => {
        setPalavraFest([]);
        const idxGrupo = grupos.findIndex(
            g => g.idGrupoPequeno === grpSelecionado.idGrupoPequeno
        );
        if (idxGrupo !== -1) {
            history.push(`/controle_palavra_fest/${idxGrupo}`);
        }
        carregarTab(grpSelecionado);
    };

    const selecionarSemana = (event, valor) => {
        setSemana(valor);
    };

    const handleParticipacaoMembro = async (event, idxMembro) => {
        if (!dentroDoPeriodo) {
            return;
        }

        const { checked } = event.target;

        const membro = palavraFest[idxMembro];

        //if (membro.tipo !== 3) {
        //    return;
        //}

        membro.participa = checked;

        const novoPalavraFest = [...palavraFest];
        novoPalavraFest[idxMembro] = membro;

        setPalavraFest(novoPalavraFest);

        try {
            await salvarParticipacaoMembro(membro.idMembro, checked);
        } catch (err) {
            membro.participa = !checked;
            novoPalavraFest[idxMembro] = membro;

            setPalavraFest(novoPalavraFest);
        }
    };

    const handleSalvarItem = async (
        event,
        membro,
        idItem,
        idxMembro,
        idxItem
    ) => {
        const { checked } = event.target;

        try {
            setItens({
                ...itens,
                [MAX_ELEMENTS * idxMembro + idxItem]: checked,
            });
            if (grupoSelecionado.isCriancaPalavraFest) {
                await salvarItemCrianca(membro.id, idItem, checked);
            } else {
                await salvarItem(membro.idAluno, idItem, checked);
            }
        } catch (err) {
            setItens({
                ...itens,
                [MAX_ELEMENTS * idxMembro + idxItem]: !checked,
            });
        }
    };

    const handlePopoverOpen = (event, tipoMembro) => {
        if (tipoMembro < 3) setSwitchLiderEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setSwitchLiderEl(null);
    };

    const calcularPercentual = (idxItem) => {
        const participantes = palavraFest.filter(m => m.participa);
        if (participantes.length === 0) return null;
        const realizaram = participantes.filter(m => {
            const idx = palavraFest.indexOf(m);
            return itens[MAX_ELEMENTS * idx + idxItem];
        }).length;
        return Math.round((realizaram / participantes.length) * 100);
    };

    const percentualMeditacao = calcularPercentual(0);
    const percentualLeitura = calcularPercentual(1);
    const percentualMemorizacao = calcularPercentual(2);

    return (
        <>
            {palavraFestInativo ? (
                <Box display="flex" justifyContent="center" alignItems="center" mt={6}>
                    <Card style={{ maxWidth: 420, textAlign: 'center' }}>
                        <CardContent>
                            <EventBusy style={{ fontSize: 48, color: '#9e9e9e', marginBottom: 16 }} />
                            <Typography variant="h6" gutterBottom>
                                Palavra Fest
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                {mensagemInativo}
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            ) : !isCarregandoGrupo &&
                grupos.length > 0 ? (
                <div className={classes.tab}>
                    <AppBar position="static" style={{ zIndex: 1000 }}>
                        <Tabs
                            value={grupoSelecionado}
                            onChange={selecionarGrupo}
                        >
                            {grupos.map((grupo, i) => (
                                <Tab
                                    key={grupo.idGrupoPequeno}
                                    value={grupo}
                                    label={
                                        grupos.length > 1 ? `GA DE ${grupo.txDiaSemanaReuniao}` : 'MEU GA'
                                    }
                                    {...a11yProps(1)}
                                />
                            ))}
                        </Tabs>
                    </AppBar>
                    <TabPanel value={grupoSelecionado} index={grupoSelecionado}>
                        {isCarregandoSemana ? (
                            <Box display="flex" justifyContent="center" mt={4}>
                                <CircularProgress />
                            </Box>
                        ) : (
                        <>
                        {mostrarFestaVitoria && (
                            <Box mt={2}>
                                <Chip
                                    icon={
                                        desafioMeditacao.conseguiu ? (
                                            <Check />
                                        ) : (
                                            <Block />
                                        )
                                    }
                                    label={
                                        desafioMeditacao.conseguiu
                                            ? 'GA aprovado para a Festa da Vitória'
                                            : 'GA não aprovado para a Festa da Vitória'
                                    }
                                    color={
                                        desafioMeditacao.conseguiu
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                    style={
                                        desafioMeditacao.conseguiu
                                            ? {}
                                            : { backgroundColor: '#B80F0A' }
                                    }
                                />
                            </Box>
                        )}
                        <FormControl
                            component="fieldset"
                            className={classes.radiogroup}
                        >
                            <RadioGroup
                                row
                                aria-label="position"
                                name="position"
                                value={semana}
                                onChange={selecionarSemana}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio color="primary" />}
                                    label="Semana 1"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    value="2"
                                    control={<Radio color="primary" />}
                                    label="Semana 2"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    value="3"
                                    control={<Radio color="primary" />}
                                    label="Semana 3"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                        </FormControl>
                        {percentualMeditacao !== null && (
                            <Box ml={1} mt={1} px={2} py={1} style={{ backgroundColor: '#fff', borderRadius: 8, maxWidth: 420, boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
                                <Box mt={1} maxWidth={400}>
                                    {[
                                        { label: 'Meditação', valor: percentualMeditacao, colorir: true },
                                        { label: 'Leitura', valor: percentualLeitura, colorir: true },
                                        { label: 'Memorização', valor: percentualMemorizacao, colorir: true },
                                    ].map(item => (
                                        <div key={item.label} className={classes.progressRow}>
                                            <Typography variant="body2" className={classes.progressLabel}>
                                                {item.label}
                                            </Typography>
                                            <LinearProgress
                                                variant="determinate"
                                                value={item.valor}
                                                className={item.colorir ? (item.valor >= 90 ? classes.progressBarGreen : classes.progressBarRed) : classes.progressBar}
                                                style={{
                                                    backgroundColor: '#e0e0e0',
                                                }}
                                            />
                                            <Typography variant="body2" className={classes.progressValue}>
                                                {item.valor}%
                                            </Typography>
                                        </div>
                                    ))}
                                </Box>
                            </Box>
                        )}
                        <Box ml={1} mt={1}>
                            <Typography variant="body2" style={{ color: '#F44336', fontStyle: 'italic' }}>
                                Desative a participação apenas nos motivos de caso fortuito ou força maior. Dúvidas? Procure a liderança do seu GA.
                            </Typography>
                        </Box>
                        <Grid container spacing={2} className={classes.grid}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    {palavraFest.map((membro, idxMembro) => (
                                        <Grid
                                            key={membro.idMembro}
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                        >
                                            <Card>
                                                <CardHeader
                                                    avatar={
                                                        <Avatar
                                                            className={
                                                                classes.avatar
                                                            }
                                                            src={
                                                                !grupoSelecionado.isCriancaPalavraFest
                                                                    ? membro.txFotoUrl
                                                                    : membro.txNome
                                                            }
                                                            alt={
                                                                !grupoSelecionado.isCriancaPalavraFest
                                                                    ? membro.txMembro
                                                                    : membro.txNome
                                                            }
                                                        />
                                                    }
                                                    title={
                                                        <span translate="no">
                                                            {!grupoSelecionado.isCriancaPalavraFest
                                                                ? membro.txMembro
                                                                : membro.txNome}
                                                        </span>
                                                    }
                                                    action={
                                                        !grupoSelecionado.isCriancaPalavraFest &&
                                                        membrosMemorizacao.includes(membro.idMembro) ? (
                                                            <Tooltip title="Cumpriu o desafio da memorização">
                                                                <EmojiEvents style={{ color: '#FFD700', marginTop: 8, marginRight: 8 }} />
                                                            </Tooltip>
                                                        ) : null
                                                    }
                                                />
                                                <CardContent
                                                    className={
                                                        classes.cardContent
                                                    }
                                                >
                                                    {!grupoSelecionado.isCriancaPalavraFest && (
                                                        <div className={classes.switchWrapper}>
                                                            <FormControlLabel
                                                                key={
                                                                    membro.idMembro
                                                                }
                                                                label={
                                                                    palavraFest[
                                                                        idxMembro
                                                                    ].participa
                                                                        ? 'Participa do Palavra Fest'
                                                                        : 'Não participa do Palavra Fest'
                                                                }
                                                                className={
                                                                    classes.switchItem
                                                                }
                                                                control={
                                                                    <Switch
                                                                        color="primary"
                                                                        disabled={!dentroDoPeriodo}
                                                                        checked={
                                                                            palavraFest[
                                                                                idxMembro
                                                                            ]
                                                                                .participa
                                                                        }
                                                                        onChange={event => {
                                                                            handleParticipacaoMembro(
                                                                                event,
                                                                                idxMembro
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                                onMouseEnter={event => {
                                                                    handlePopoverOpen(
                                                                        event,
                                                                        membro.tipo
                                                                    );
                                                                }}
                                                                onMouseLeave={
                                                                    handlePopoverClose
                                                                }
                                                            />
                                                        </div>
                                                    )}

                                                    {membro.itens.map(
                                                        (item, idxItem) => (
                                                            <FormControlLabel
                                                                key={
                                                                    (!grupoSelecionado.isCriancaPalavraFest
                                                                        ? membro.idAluno
                                                                        : membro.id) +
                                                                    item.idRodadaMateriaItemAvaliativo
                                                                }
                                                                label={
                                                                    item.txItemAvaliativo
                                                                }
                                                                className={
                                                                    classes.item
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        color="primary"
                                                                        checked={
                                                                            (grupoSelecionado.isCriancaPalavraFest ||
                                                                                membro.participa) &&
                                                                            itens[
                                                                            MAX_ELEMENTS *
                                                                            idxMembro +
                                                                            idxItem
                                                                            ]
                                                                        }
                                                                        disabled={
                                                                            !admin &&
                                                                            ((!grupoSelecionado.isCriancaPalavraFest &&
                                                                                !membro.participa) ||
                                                                                !item.habilitado)
                                                                        }
                                                                        onChange={event => {
                                                                            handleSalvarItem(
                                                                                event,
                                                                                membro,
                                                                                item.idRodadaMateriaItemAvaliativo,
                                                                                idxMembro,
                                                                                idxItem
                                                                            );
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                        </>
                        )}
                    </TabPanel>
                </div>
            ) : (
                <div>
                    {grupos.length === 0 && isCarregandoGrupo
                        ? 'Carregando...'
                        : ''}
                </div>
            )}
            <InformationDialog
                titulo="Controle Palavra Fest"
                open={mostrarModalGrupo}
                handleClose={() => history.push(`/grupos`)}
            >
                {`Para fazer o lançamento das tarefas do Palavra Fest você precisa cadastrar pelo menos uma criança. Você será redirecionado para esta opção.`}
            </InformationDialog>
            {/* <Popover
                id="popover-switch-lider"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={showPopoverSwitchLider}
                anchorEl={switchLiderEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography>
                    Líder não pode alterar sua participação no Palavra Fest
                </Typography>
            </Popover> */}
        </>
    );
};

export default ControlePalavraFest;
